import {getCorePrefix} from "Services/Endpoints";

const prefix = getCorePrefix();

export const API_LOCATIONS = {
    locations: `${prefix}locations/`,
    accountLocations: (id) => `${prefix}locations-dropdown?account_id=${id}`,
    statusTypes: `${prefix}locations/status/types`,
};
